import { Outlet, useLoaderData, useLocation, useParams } from "react-router-dom";
import { TrainingsMenu } from "./components/TrainingsMenu";
import MeaLink from "../../components/MeaLink";
import { useAuthContext } from "../../hooks/useAuthContext";
import MeaPage from "../../components/MeaPage";
import MeaPageTitle from "../../components/MeaPageTitle";
import { BreadCrumb } from "primereact/breadcrumb";
import trainingsAPI from "../../services/trainings";
import { Ripple } from "primereact/ripple";
import { Dialog } from "primereact/dialog";
import { useState, useEffect } from "react";
import { useMemberActivityTracking } from "../../hooks/useMemberActivityTracking";

export async function loader({ params }) {
  // Note: member_id will be passed from the component that uses this loader
  // For now, we'll get it from the current membership context in the component
  const result = await trainingsAPI.GetOneTraining(params.schoolId, params.trainingId);
  return { training: result?.data };
}

export function TrainingsLayout() {

  const { training } = useLoaderData();

  const location = useLocation();
  const isPrintRoute = location.pathname.includes("/print-") || location.pathname.includes("/print");

  const { currentMembership } = useAuthContext();
  const params = useParams();
  const schoolId = params.schoolId || currentMembership?.school?.id;
  const trainingId = params.trainingId;
  const { trackActivity } = useMemberActivityTracking();
  
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (mobileMenuVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    // Cleanup on unmount
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [mobileMenuVisible]);

  // Track member activity when trainings layout is rendered
  useEffect(() => {
    if (currentMembership?.id) {
      trackActivity(""); // Empty access token since we're using credentials: "include"
    }
  }, [currentMembership, trackActivity]);

  if (isPrintRoute) {
    return <Outlet />;
  }

  const breadcrum = [
    {
      template: () => (
        <a 
          href="#" 
          className="p-breadcrumb p-ripple cursor-pointer block lg:hidden text-700"
          onClick={(e) => {
            e.preventDefault();
            setMobileMenuVisible(true);
          }}
        >
          <i className="p-ripple pi pi-bars"></i>
          <Ripple />
        </a>
      )
    },
    {
      template: () => <MeaLink to={`/school/${schoolId}/admin`} icon="pi pi-home" isRipple={true}>{currentMembership?.school?.name}</MeaLink>
    },
    {
      template: () => <MeaLink to={`/school/${schoolId}/admin/trainings`} isRipple={true}>Formations</MeaLink>
    },
    { label: training?.name }
  ];

  return (
    <>
      <MeaPage
        isSurfaceSection={false}
        breadcrumb={<BreadCrumb model={breadcrum} className="w-full" />}
      >
        <div className="flex relative flex-auto">
          <div 
            id="app-sidebar-12" 
            className="surface-card hidden lg:block flex-shrink-0 absolute lg:static left-0 top-0 z-1 select-none shadow-2 w-15rem"
          >
            <TrainingsMenu />
          </div>
          <div className="flex flex-column flex-auto min-w-0 lg:ml-2">
            <div className="flex-auto w-full">
              <Outlet />
            </div>
          </div>
        </div>
      </MeaPage>

      {/* Mobile Menu Modal - Outside MeaPage for true fullscreen */}
      {mobileMenuVisible && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column'
          }}
          className="lg:hidden"
        >
          <div style={{
            backgroundColor: 'white',
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <div style={{
              padding: '1rem',
              borderBottom: '1px solid #e0e0e0',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              flexShrink: 0
            }}>
              <h2 style={{ margin: 0, fontSize: '1.25rem', fontWeight: '600' }}>Menu</h2>
              <button 
                onClick={() => setMobileMenuVisible(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  padding: '0.5rem'
                }}
              >
                ×
              </button>
            </div>
            <div style={{
              flex: 1,
              overflow: 'auto',
              padding: '1rem'
            }}>
              <TrainingsMenu onItemClick={() => setMobileMenuVisible(false)} />
            </div>
          </div>
        </div>
      )}
    </>
  )
}